import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { LoginService } from './login.service';
import { first } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PrincipalService } from 'src/app/core/security/authentication/principal.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [LoginService]
})
export class LoginComponent implements OnInit {
  public background: string = environment.login.background;
  public header: string = environment.login.header;

  public hide = true;

  credentials: {
    username: string;
    password: string;
  };

  loading: boolean;
  authError: boolean;

  constructor(
    public route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    public snackBar: MatSnackBar,
    private principalService: PrincipalService
  ) {
    this.credentials = {
      username: '',
      password: ''
    };
    this.loading = false;
    this.authError = false;
  }

  ngOnInit() {
    document.cookie = 'JSESSIONID=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = 'JSESSIONID=; Path=/api/authentication; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    //console.log('login.component - logout - cookie:', document.cookie);
    if ((this.principalService) && (this.principalService.getUser()) &&  (this.principalService.getUser().username)){
      //console.log('login.component - logout');
      this.loginService.logout(this.principalService.getUser().username);
    }
  }

  login(form?: any) {
    this.loading = true;
    this.loginService
      .login(this.credentials.username, this.credentials.password)
      .pipe(first())
      .subscribe(
        data => {
          this.router.navigate(['/']);
        },
        error => {
          this.loading = false;
          this.snackBar.open(error.error.description, '', {
            duration: 20000,
            panelClass: ['red-snackbar']
          });
        }
      );
  }
}
